import api from './apiConfig';

const processCodexService = {

  getAll: async (params = {}) => {
    try {
      // Ensure pagination parameters are properly formatted
      const queryParams = {
        page: params.page || 0,
        size: params.size || 10,
        sort: params.sort || 'createdAt,desc',
        ...params
      };
      
      const response = await api.get('/codex-processes', { params: queryParams });
      return response.data;
    } catch (error) {
      console.error('Error fetching codex processes:', error);
      throw error;
    }
  },

  // Get all codexes for a process
  getByProcessId: async (processId) => {
    try {
      const response = await api.get(`/codex-processes/${processId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching codexes for process ${processId}:`, error);
      throw error;
    }
  },

  // Cancel a running process
  cancelProcess: async (processId) => {
    try {
      const response = await api.post(`/codex-processes/${processId}/cancel`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error(`Error cancelling process ${processId}:`, error);
      throw error;
    }
  },
    
};

export default processCodexService; 